import { Card, Col, Row, Tooltip, Typography } from "antd";

import React from "react";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, XAxis, YAxis } from "recharts";


const workingHoursData = Array.from({ length: 31 }, (_, i) => ({
    day: i + 1,
    hours: [8, 0, 7, 6, 0, 9, 8, 0, 6, 7, 0, 9, 10, 8, 0, 6, 7, 0, 8, 9, 0, 6, 7, 0, 9, 8, 6, 0, 8, 8, 9][i]
}));

const WorkingHours: React.FC = () => {
    const { Title, Text } = Typography;
    return (
       <>
         <Title level={3}>My Performance</Title>
            <Row gutter={[16, 16]}>


                <Col span={24}>
                    <Card title="Working Hours Trends">
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={workingHoursData}>
                                <Line type="monotone" dataKey="hours" stroke="#00bcd4" strokeWidth={2} />
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="day" />
                                <YAxis />
                                <Tooltip />
                            </LineChart>
                        </ResponsiveContainer>
                    </Card>
                </Col>


            </Row>
       
       </>
    );
};

export default WorkingHours;
